import {QuoteTemplateParams} from '../quoteTemplateParams';
import {highlightYellow} from '../../helpers/highlightYellow';

import {emailHeaderCompanyLogo, paragraphSeparator} from '../../helpers/commonEmailComponents';

export default function afterSaleIULNonblend(params: QuoteTemplateParams) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const {
        name,
        monthly_premium: monthlyPremium,
        cash_age: cashAge,
        cash_value: cashValue,
        life_coverage: lifeCoverage,
        carrier_name: carrierName,
        has_illustration: hasIllustration,
    } = params;
    return `
${emailHeaderCompanyLogo} 
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Hi ${highlightYellow(name)},</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Congratulations on submitting your life insurance application through Amplify. You’re one step closer to getting the coverage you need while building wealth with a new, customized IUL policy.</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">To summarize, here are the policy details with ${highlightYellow(carrierName || '{carrierName}')} that we discussed:</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span style="background-color: #ffffff; font-size: 12pt; font-family: 'Georgia'; font-weight: 400;">&#9989;
        </span><span
            style="color: #000000; font-weight: 700; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">${highlightYellow(lifeCoverage)} of lifetime insurance protection</span><span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">, payable tax-free to your beneficiary</span>
    </p>
    <ul style="padding: 0; margin: 0; list-style-type: disc;">
        <li style="color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left; margin-left: 36pt; padding-left: 0pt;">
            <span
                style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Your policy also has extra benefits, including critical, chronic & terminal illness protection</span>
        </li>
    </ul>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span style="background-color: #ffffff; font-size: 12pt; font-family: 'Georgia'; font-weight: 400;">&#9989;
        </span><span
            style="color: #000000; font-weight: 700; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;"><span>${highlightYellow(cashValue)}  retirement cash at age </span><span>${highlightYellow(
                cashAge,
            )}</span>
    </p>
    <ul style="padding: 0; margin: 0; list-style-type: disc;">
        <li style="color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left; margin-left: 36pt; padding-left: 0pt;">
            <span
                style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Your IUL policy has the added security of an interest rate “floor”, meaning you’ll never suffer any stock market losses</span>
        </li>
        <li style="color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left; margin-left: 36pt; padding-left: 0pt;">
            <span
                style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">You also have the flexibility to add cash to your policy that grows tax-deferred, as well as the ability to borrow money from your account to use for any purpose</span>
        </li>
    </ul>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span style="background-color: #ffffff; font-size: 12pt; font-family: 'Georgia'; font-weight: 400;">&#9989;
        </span><span
            style="color: #000000; font-weight: 700; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">${highlightYellow(monthlyPremium)}
            monthly payment</span>
    </p>
    ${
        hasIllustration
            ? `${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">${highlightYellow('I have also attached your customized, in-depth policy illustration for your records.')}</span>
    </p>`
            : ''
    }
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">As part of our expedited application process, we will work closely with the insurance company to help secure your new policy as quickly and easily as possible.</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">As discussed, I will call you on ${highlightYellow('{date}')} at ${highlightYellow('{time}')} to review your approval and full policy details. I’ll also walk you through the easy steps to activate your new IUL. 
            If you have any questions, feel free to contact me directly at ${highlightYellow('{phone #}')}.</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Thank you for trusting Amplify Life Insurance Services with your financial future, and I look forward to speaking with you again soon!</span>
    </p>
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">Best Regards,</span>
    </p>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">${highlightYellow('[Agent signature]')}</p>
    ${paragraphSeparator}
    ${paragraphSeparator}
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">P.S. For your reference, feel free to review our <span
            style="text-decoration-skip-ink: none; -webkit-text-decoration-skip: none; color: #1155cc; text-decoration: underline;"><a
                href="https://www.getamplifylife.com/guide"
                style="color: inherit; text-decoration: inherit;">Guide to Life Insurance</a></span><span>&nbsp;and our
        </span> to learn more about all of the benefits and features of your IUL policy.</span>
    </p>
    `;
}
